/**
 * Document Import Wizard Step Configuration
 *
 * Centralized configuration for the 2-step document import wizard.
 * Follows the same pattern as Masters/config/wizardSteps.js
 */

/**
 * Step number constants
 */
export const WIZARD_STEPS = {
  CONFIGURE: 1,
  REVIEW: 2,
  SUCCESS: 3,
};

/**
 * Step metadata for sidebar navigation
 */
export const STEP_INFO = [
  {
    step: WIZARD_STEPS.CONFIGURE,
    title: 'Configure',
    description: 'Setup & upload files',
    icon: 'mdi-cog',
  },
  {
    step: WIZARD_STEPS.REVIEW,
    title: 'Review',
    description: 'Confirm & import',
    icon: 'mdi-file-check',
  },
  // Success step is not shown in navigation
  {
    step: WIZARD_STEPS.SUCCESS,
    title: 'Success',
    description: 'Import complete',
    icon: 'mdi-check-circle',
  },
];

/**
 * Calculate progress percentage based on current step
 * @param {number} currentStep - Current wizard step
 * @returns {number} Progress percentage (0-100)
 */
export function calculateProgress(currentStep) {
  // 2-step wizard: Configure = 50%, Review = 100%
  const stepProgress = {
    [WIZARD_STEPS.CONFIGURE]: 50,
    [WIZARD_STEPS.REVIEW]: 100,
    [WIZARD_STEPS.SUCCESS]: 100,
  };
  return stepProgress[currentStep] || 0;
}

/**
 * Get step info by step number
 * @param {number} step - Step number
 * @returns {Object|undefined} Step info object
 */
export function getStepInfo(step) {
  return STEP_INFO.find(s => s.step === step);
}

/**
 * Check if step is valid
 * @param {number} step - Step number to validate
 * @returns {boolean} True if valid step
 */
export function isValidStep(step) {
  return Object.values(WIZARD_STEPS).includes(step);
}
